import { Routes, Route } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import { AuthContext } from "./context/AuthContext";
import DisclaimerPopup from "./components/DisclaimerPopup.jsx";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Cal from "./pages/Cal";
import Result from "./pages/Result";
import Login from "./pages/Login";
import Register from "./pages/Register";

import ProtectedRoute from "./routes/protectedRoutes";

function App() {
  const { loading, user } = useContext(AuthContext);
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  useEffect(() => {
    if (user) { 
      const accepted = localStorage.getItem("jrj_disclaimer_accepted");
      if (!accepted) {
        setShowDisclaimer(true);
      }
    } else {
      setShowDisclaimer(false);
    }
  }, [user]);

  const handleAccept = () => {
    localStorage.setItem("jrj_disclaimer_accepted", "yes");
    setShowDisclaimer(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Checking session...
      </div>
    );
  }

  return (
    <>
      {showDisclaimer && <DisclaimerPopup onAccept={handleAccept} />}
      <Navbar />
      <main className={`w-full px-4 sm:px-6 ${showDisclaimer ? "opacity-30 pointer-events-none" : ""}`}>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected Home */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />

          <Route
            path="/cal"
            element={
              <ProtectedRoute>
                <Cal />
              </ProtectedRoute>
            }
          />

          <Route
            path="/result"
            element={
              <ProtectedRoute>
                <Result />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;
